import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MQTTModel } from '@rift/models/restapi/MQTT.Model';
import { ResultModel } from '@rift/models/restapi/Result.Model';
import { ConnectionTokenService } from '@rift/service/connection/ConnectionToken.Service';
import { RiftRestApiService } from '@rift/service/restapi/base/RiftRestApi.Service';
import { ConfigurationService } from '@shared/service/configuration/Configuration.Service';
import { ProcessMonitorServiceProcess } from '@shared/service/processmonitor/ProcessMonitor.Service.Process';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { RestModelUtility } from '@shared/utility/RestModel.Utility';
import { MatDialog } from '@angular/material/dialog';

@Injectable()
export class RestApiMQTTService extends RiftRestApiService {
    private _controller = 'mqtt';

    public constructor(
        private readonly _dialog: MatDialog,
        private readonly _connectionTokenService: ConnectionTokenService,
        private readonly _config: ConfigurationService,
        private readonly _httpClient: HttpClient) {
        super(_dialog, _config.riftV1RestApiBase, _httpClient, _connectionTokenService);
    }

    public getMQTT(process?: ProcessMonitorServiceProcess): Observable<MQTTModel> {
        return this.get<MQTTModel>(`${this._controller}`, MQTTModel, this.getTokenParams(), process).pipe(
            map(result => this.handleErrorOrThrow(result))
        );
    }

    public setMQTT(date: MQTTModel, process?: ProcessMonitorServiceProcess): Observable<ResultModel> {
        return this.put<MQTTModel, ResultModel>(`${this._controller}`, date, ResultModel, this.getTokenParams(), process).pipe(
            map(result => this.handleErrorOrThrow(result))
        );
    }
}
